import axios from "./axios";

export interface RevenueSummary {
  freeReads: number;
  premiumReads: number;
  singleUnlockReads: number;
  premiumRevenue: number;
  singleUnlockRevenue: number;
  totalRevenue: number;
}

export interface ContentRevenueItem {
  contentId: string;
  contentTitle: string;
  freeReads: number;
  premiumReads: number;
  singleUnlockReads: number;
  premiumRevenue: number;
  singleUnlockRevenue: number;
  totalRevenue: number;
}

export interface ContentRevenueResponse {
  summary: RevenueSummary;
  items: ContentRevenueItem[];
}

export interface ContentPartRevenueItem {
  contentPartId: string;
  title: string;
  freeReads: number;
  premiumReads: number;
  singleUnlockReads: number;
  premiumRevenue: number;
  singleUnlockRevenue: number;
  totalRevenue: number;
}

export interface ContentPartRevenueResponse {
  summary: RevenueSummary;
  items: ContentPartRevenueItem[];
}

export interface PackageSalesItem {
  packageTierId: string;
  packageName: string;
  unitPrice: number;
  count: number;
  estimatedRevenue: number;
  startDateUtc?: string;
  endDateUtc?: string;
}

export interface PackageSalesResponse {
  summary: {
    totalCount: number;
    totalEstimatedRevenue: number;
  };
  items: PackageSalesItem[];
}

export interface UserSearchItem {
  id: string;
  name: string;
  email: string;
  zTokens?: number;
}

export interface UserRevenueSummary {
  packageSpend: number;
  singleSpend: number;
  premiumConsumptionZ: number;
  totalSpend: number;
  freeReads: number;
  premiumReads: number;
  singleReads: number;
}

export interface UserRevenueStats {
  summary: UserRevenueSummary;
  packages: PackageSalesItem[];
}

export async function getContentRevenue(start?: string, end?: string): Promise<ContentRevenueResponse> {
  const params: Record<string, string> = {};
  if (start) {
    params.start = start;
  }
  if (end) {
    params.end = end;
  }

  const res = await axios.get("/admin/reports/content-revenue", { params });
  return res.data as ContentRevenueResponse;
}

export async function getContentPartRevenue(contentId: string, start?: string, end?: string): Promise<ContentPartRevenueResponse> {
  const params: Record<string, string> = {};
  if (start) {
    params.start = start;
  }
  if (end) {
    params.end = end;
  }

  const res = await axios.get(`/admin/reports/content/${contentId}/part-revenue`, { params });
  return res.data as ContentPartRevenueResponse;
}

export async function getPackageSales(start?: string, end?: string): Promise<PackageSalesResponse> {
  const params: Record<string, string> = {};
  if (start) params.start = start;
  if (end) params.end = end;

  const res = await axios.get("/admin/reports/package-sales", { params });
  return res.data as PackageSalesResponse;
}

export async function searchUsers(q: string): Promise<UserSearchItem[]> {
  const res = await axios.get("/admin/reports/user-search", { params: { q } });
  return res.data as UserSearchItem[];
}

export async function getUserRevenueStats(userId: string, start?: string, end?: string): Promise<UserRevenueStats> {
  const params: Record<string, string> = {};
  if (start) params.start = start;
  if (end) params.end = end;
  const res = await axios.get(`/admin/reports/user-stats/${userId}`, { params });
  return res.data as UserRevenueStats;
}
